import $ from 'jquery';
// var dt = require('datatables.net')();
import dt from 'datatables.net-dt'
import { url } from '../../weburl';
import { AdminNav } from '../mini-components/admin_nav';
// dt()

export const AdminUsers = () =>
{
    $(document).ready(function ()
    {

        $('#users_table_id').DataTable({

            ajax: {
                url: `${url}api/users`,
                "method": "GET",
                dataSrc: '',

            },
            columns: [
                { data: "id" },
                { data: "username" },
                { data: "uid" },
                { data: "email" },
                { data: "phone_number" },
                { data: "contact_address" },
                

            ],
            "bDestroy": true

        })
    })

    return (
        <div className='container-fluid'>
           
            {/* <div class="row">
                <AdminNav />
            </div> */}
            <div class="row align-items-center justify-content-center">
                <div className='col-md-6'>
                    <h4 className='text-uppercase'>Users</h4>
                </div>
            </div>
            <div class="row align-items-center justify-content-center">
                <div className='col-md-12'>
                    <table  id="users_table_id" class="display" className='table  table-sm table-bordered '>
                        <thead className=''>
                            <tr>
                                <th>Id</th>
                                <th>Username</th>
                                <th>Uid</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Contact Address</th>
                               
                                


                            </tr>
                        </thead>
                        <tbody className=''>
                           
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}